<template>
  <Portlet
    title="Request Report"
    icon="chart-area"
    class="requestReport"
  >
    <LoadingPlaceholder v-if="loading" />
    <template v-else>
      <template v-if="reportAvailable">
        <table class="defaultTable w-100">
          <colgroup>
            <col>
            <col width="90">
            <col width="140">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th class="font-weight-bold">
                User Name
              </th>
              <th class="font-weight-bold">
                Requests
              </th>
              <th class="font-weight-bold">
                Last Request
              </th>
              <th class="font-weight-bold">
                Last Path
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in report"
              :key="'tr' + index"
            >
              <td v-if="item.userName">
                {{ item.userName }}
              </td>
              <td v-if="item.requestCount">
                {{ item.requestCount }}
              </td>
              <td v-tooltip="dateTime_dateTime(item.lastRequest)">
                {{ dateTime_fromNow(item.lastRequest) }}
              </td>
              <td v-if="item.requestCount">
                {{ item.lastPath }}
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template v-else>
        {{ $t('noDataAvailable') }}
      </template>
    </template>
  </Portlet>
</template>

<script>
import { dateTimeMixin } from '@/mixins/dateTimeMixin.js'

export default {
  name: "RequestReport",
  mixins: [
    dateTimeMixin
  ],
  data () {
    return {
      loading: true,
      report: null
    };
  },
  computed: {
    reportAvailable () {
      if (this.report == null) {
        return false;
      }
      if (this.report.length == null) {
        return false;
      }
      if (this.report.length === 0) {
        return false;
      }
      return true;
    }
  },
  created () {
    this.getReport();
  },
  methods: {
    getReport () {
      this.loading = true;
      this.axios.get('RequestAnalyse/GetReports')
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          this.report = response.data;
        })
         .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>


